<template>
  <div>
    <FiltroUsuario v-model="showFiltro" @filtrar="changeFiltro" :unimedId="unimedId" :unimedNome="unimedNome" />
    <v-row class="mb-2">
      <!--             <v-row justify="end">
                <v-col class="mt-2" cols="auto">
                    <icon name="download" :size="20" style="cursor: pointer" tooltip="Exportar"/>
                </v-col>
                <v-col cols="auto">
                    <button-cadu text="FILTRAR" @click="showFiltro = true" />
                </v-col>
            </v-row> -->
    </v-row>
    <table-cadu
      class="usuarios"
      v-model="selected"
      custom
      showDownload
      :showCheck="false"
      :items="['05', '10', '15', '20']"
      :elementsPerPageProp="tamanhoPagina"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :qtResultados="qtResultados"
      :rows="rows"
      :rowsHeader="rowsHeader"
      :disabledButtons="[true]"
      :ordemProp="ordemProp"
      :loading="loading"
      nameTab="TabelaUsuarios"
      @clickButton="clickButton"
      @ordena="(obj) => changeOrdem(obj)"
      @change-element="(element) => changeSelect(element)"
      @change-page="(page) => changePage(page)"
      @filtro-click="showFiltro = true"
      @download="loadingDownload"
    />

    <overlay-loading v-model="loadingOverlay" />

    <error-modal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

import FiltroUsuario from './FiltroUsuario'
import GerenciamentoUsuarios from '@/services/GerenciamentoUsuarios/GerenciamentoUsuarios'
import Usuario from '@/services/Usuario'

export default {
  components: {
    FiltroUsuario
  },

  data() {
    return {
      ordemProp: 'desc',
      selected: [],
      showFiltro: false,
      rows: [],
      rowsHeader: [
        { text: 'Unimed', icon: 'repeat' },
        { text: 'Nome Colaborador', icon: 'repeat' },
        { text: 'Login', icon: 'repeat' },
        { text: 'Perfil de Acesso', icon: 'repeat' }
      ],
      loading: false,
      colaboradorNome: '',
      loginNome: '',
      ordenacaoNome: '',
      pagina: 1,
      papelId: '',
      unimedId: null,
      unimedNome: '',
      tamanhoPagina: '10',
      tokenBearer: localStorage.getItem('tokenBearer'),
      qtPaginas: 1,
      qtResultados: 5,
      loadingOverlay: false,
      role: '',
      error: false,
      errObj: {}
    }
  },
  async beforeMount() {
    this.loadingUsuarios()
    this.role = jwtDecode(this.tokenBearer).role
    if (this.role !== 'admin_brasil') {
      await this.getUnimedId()
    }
  },
  methods: {
    async loadingUsuarios() {
      this.loading = true
      await this.getUsuarios()
      this.loading = false
    },
    async getUsuarios() {
      let gerenciamentoUsuarios = new GerenciamentoUsuarios(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseGet = await gerenciamentoUsuarios.getUsuarios(this.getArgs())
        responseGet = responseGet.data
        this.pagina = responseGet.pagina
        this.qtResultados = responseGet.qtResultados
        this.qtPaginas = responseGet.qtPaginas
        this.rows = responseGet.conteudo
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    async getUnimedId() {
      let usuario = new Usuario(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseGet = await usuario.getUnimed()
        responseGet = responseGet.data
        this.unimedId = responseGet.id
        this.unimedNome = `${responseGet.codigo} - ${responseGet.nomeFantasia}`
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    changeFiltro(obj) {
      this.showFiltro = false
      this.colaboradorNome = obj.colaboradorSelecionado
      this.unimedId = obj.unimedId
      this.papelId = obj.papelId
      this.loginNome = obj.login
      this.pagina = 1
      this.loadingUsuarios()
    },
    changeOrdem(obj) {
      this.ordenacaoNome = this.rowsHeader[obj.index].text
      const res = () => {
        switch (obj.index) {
          case 0:
            return 'unimed.versaoAtiva.codigo'
          case 1:
            return 'nome'
          case 2:
            return 'login'
          case 3:
            return 'papel'
        }
      }
      this.ordenacaoNome = res()
      this.ordemProp = obj.ordem
      this.loadingUsuarios()
    },
    clickButton(obj) {
      this.$emit('viewModal', this.rows[obj.index])
    },
    changePage(page) {
      this.pagina = page.currentPage
      this.loadingUsuarios()
    },
    changeSelect(select) {
      this.tamanhoPagina = select
      this.loadingUsuarios()
    },
    async loadingDownload() {
      this.loadingOverlay = true
      await this.downloadUsuarios()
      this.loadingOverlay = false
    },
    async downloadUsuarios() {
      let gerenciamentoUsuarios = new GerenciamentoUsuarios(this.tokenBearer, this.$appConfig.config.API)

      try {
        let response = await gerenciamentoUsuarios.downloadUsuarios(this.getArgs())
        let content = response.headers['content-disposition']
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', content.substring(content.indexOf('"'), content.lastIndexOf('"')))
        document.body.appendChild(link)
        link.click()
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    getArgs() {
      let args = this.geradorParams(
        // PAGINAÇÃO
        {
          name: 'pagina',
          value: this.pagina
        },
        {
          name: 'tamanhoPagina',
          value: this.tamanhoPagina
        },
        {
          name: 'ordenacao',
          value: this.ordenacaoNome
        },
        {
          name: 'direcaoOrdenacao',
          value: this.ordemProp
        },
        //  FILTRO
        {
          name: 'unimedId',
          value: this.unimedId
        },
        {
          name: 'colaboradorNome',
          value: this.colaboradorNome
        },
        {
          name: 'papelId',
          value: this.papelId
        },
        {
          name: 'login',
          value: this.loginNome
        }
      )
      return args
    },
    geradorParams(...params) {
      let str = ''
      for (let p of params) {
        if (p.value) {
          str += `${p.name}=${p.value}&`
        }
      }
      if (params.length > 0) {
        str = str.substring(0, str.length - 1)
      }
      return str
    }
  }
}
</script>

<style lang="sass">
.usuarios > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important
    padding-bottom: 4px
    padding: 0px !important

.usuarios > .table-cadu > .table
  max-height: 250px
  overflow: auto
  table
    width: 100%
</style>
